import React from 'react';

interface Props {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder: string;
}

const SearchBar: React.FC<Props> = ({
  searchTerm,
  onSearchChange,
  placeholder
}) => {
  return (
    <div className="search-bar">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchBar;
